module.exports = __webpack_public_path__ + "static/img/企业logo2.c28bf08f.jpeg";